import { MdClose } from "react-icons/md";
import { Container, SubModulesNavHeader, Button } from "./styles";
import useModal, { Label } from "../../../hooks/useModal";
import useModalSelecaoTalhoes from "../../../hooks/useModalSelecaoTalhoes";

type Props = {
    label: string;
    newList: Label[] | undefined;
    onTabChange: (tabId: string) => void;
    closeTabbarItem: (list: string) => void;
}

export function TabbarModal({ label, newList, onTabChange, closeTabbarItem}: Props) {
    const { isCopying } = useModal();
    const { isCopyWithImport } = useModalSelecaoTalhoes();

    return isCopying || isCopyWithImport ? (
        <Container>
            <SubModulesNavHeader>
                {
                    newList?.map((item, index) => (
                        <Button 
                            active={label === item.id}
                            key={index} onClick={() => onTabChange(item.id)}
                        >
                            <MdClose onClick={(event) => {
                                event.stopPropagation();
                                closeTabbarItem(item.id);
                            }} />
                            <span>{isCopying ? 'CÓPIA - ' : ''}{item.name}</span>
                        </Button>
                    ))
                }
            </SubModulesNavHeader>
      </Container>
    ) : null
}